import { useDispatch } from 'react-redux';
import { ClickToCallIsOpenInputDto, ClickToCallIsOpenOutputDto } from '@api/izibizi-xp';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';

export const useFetchClickToCallIsOpen = (): UseFetchHookOutput<
	Omit<ClickToCallIsOpenInputDto, 'metadata'>,
	ClickToCallIsOpenOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<ClickToCallIsOpenInputDto, ClickToCallIsOpenOutputDto>({
		operationKey: 'clickToCallIsOpen',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ clickToCallIsOpen: res.data }));
			}
		},
	});
};
